import { Injectable } from '@angular/core';
import { MatSnackBar } from '@angular/material/snack-bar';
import { SnackBarComponent } from '../components/snack-bar/snack-bar.component';
import { FeedbackActionButton, FeedbackModel, FeedbackType } from '../models/feedback.model';

@Injectable({
  providedIn: 'root',
})
export class AsyncFeedbackService {
  constructor(private snackBar: MatSnackBar) {}

  public showFeedback(feedback: FeedbackModel) {
    this.snackBar.openFromComponent(SnackBarComponent, {
      data: {
        message: feedback.message,
        icon:
          feedback.type === FeedbackType.Success
            ? 'check_box'
            : feedback.type === FeedbackType.Failure
            ? 'error'
            : 'warning',
        url: feedback.url,
        urlText: feedback.urlText,
        button: feedback.button,
      },
      duration: feedback.duration ? feedback.duration : 5000,
      panelClass:
        feedback.type === FeedbackType.Failure
          ? ['snack-bar-error']
          : feedback.type === FeedbackType.Warning
          ? ['snack-bar-warring']
          : ['snack-bar-success'],
    });
  }

  // public showFailureMessage(message: string) {
  //   this.showFeedback(new FeedbackModel(FeedbackType.Failure, message));
  // }
  public showFailureMessage(
    message: string,
    url: string = null,
    urlText: string = null,
    button: FeedbackActionButton = null
  ) {
    this.showFeedback(new FeedbackModel(FeedbackType.Failure, message, null, url, urlText, button));
  }

  public showSuccessMessage(
    message: string,
    url: string = null,
    urlText: string = null,
    button: FeedbackActionButton = null
  ) {
    this.showFeedback(new FeedbackModel(FeedbackType.Success, message, null, url, urlText, button));
  }

  public showWarningMessage(
    message: string,
    url: string = null,
    urlText: string = null,
    button: FeedbackActionButton = null
  ) {
    this.showFeedback(new FeedbackModel(FeedbackType.Warning, message, null, url, urlText, button));
  }
}
